import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InterfaceEncabezado } from '@shared/models/Interfaces/InterfaceEncabezado';

@Component({
  selector: 'app-interfaces-lista',
  templateUrl: './interfaces-lista.component.html',
  styleUrls: ['./interfaces-lista.component.scss']
})
export class InterfacesListaComponent {
  @Input() interfaces: InterfaceEncabezado[] = [];
  interfaz: InterfaceEncabezado;
  @Output() interfazSeleccionada: EventEmitter<InterfaceEncabezado> = new EventEmitter;
  cargandoInterfaces: boolean;
  @Input() mensajeError: string;

  mostrarDetalle(i: number) {
    this.interfazSeleccionada.emit(this.interfaces[i]);
    this.interfaz = this.interfaces[i];
  }

  isActive(i) {
    return this.interfaz == this.interfaces[i];
  }


  pintarInterfaz(index) {
    const estado = this.interfaces[index].estado;
    if(estado) {
      switch(estado.toLocaleLowerCase()) {
        case 'sinerror':
          return({'background-color': '#189114', 'color': '#ffff'});
        case 'pendiente':
          return({'background-color': '#fff03c'});
        case 'error': 
          return({'background-color': '#dc3545', 'color': '#ffff'});
        default:
          return({'background-color': '#ffff'});
      }
    }
    }
    
}
